import { z } from 'zod';
import { labelledUuid } from './common.js';

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be YYYY-MM-DD');

const fyYearField = z.coerce
  .number()
  .int('Year must be a whole number')
  .min(1900, 'Year must be 1900 or later')
  .max(9999, 'Year must be 9999 or earlier');

export const monthlyReportQuerySchema = z.object({
  fundId: labelledUuid('fund'),
  year: fyYearField,
  month: z.coerce
    .number()
    .int('Month must be a whole number')
    .min(1, 'Month must be 1 or higher')
    .max(12, 'Month cannot exceed 12'),
});
export type MonthlyReportQuery = z.infer<typeof monthlyReportQuerySchema>;

export const quarterlyReportQuerySchema = z.object({
  fyYear: fyYearField,
  quarter: z.coerce
    .number()
    .int('Quarter must be a whole number')
    .min(1, 'Quarter must be 1, 2, 3, or 4')
    .max(4, 'Quarter must be 1, 2, 3, or 4'),
});
export type QuarterlyReportQuery = z.infer<typeof quarterlyReportQuerySchema>;

export const annualReportQuerySchema = z.object({
  fyYear: fyYearField,
});
export type AnnualReportQuery = z.infer<typeof annualReportQuerySchema>;

export const customRangeReportSchema = z
  .object({
    fundIds: z
      .array(labelledUuid('fund'))
      .min(1, 'Select at least one fund')
      .max(20, 'Select at most 20 funds'),
    startDate: isoDate,
    endDate: isoDate,
  })
  .refine((v) => v.endDate >= v.startDate, {
    message: 'End date must be on or after start date',
    path: ['endDate'],
  });
export type CustomRangeReport = z.infer<typeof customRangeReportSchema>;

export const excelExportSchema = customRangeReportSchema;
export type ExcelExportRequest = z.infer<typeof excelExportSchema>;
